import CustomEvent from 'custom-event'

// TODO: Add to config
const eventPrefix = 'RegistrationForm'

export default {
  dispatch(eventName) {
    const event = new CustomEvent(`${eventPrefix}::${eventName}`)

    document.dispatchEvent(event)
  }
}



// WEBPACK FOOTER //
// ./src/eventDispatcher.js